<template>
  <div
    class="image-simple"
  >
    <img
      ref="image"
      class="image-simple__image"
      :alt="alt"
      :src="imageSrc"
      width="870"
      height="489"
      loading="eager"
    >
  </div>
</template>

<script>
  export default {
    props: {
      imageSrc: String,
      alt: String
    }
  };

</script>